import _asyncToGenerator from "/Users/hart/dev/applications/personal-website/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/Users/hart/dev/applications/personal-website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/Users/hart/dev/applications/personal-website/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _regeneratorRuntime from "/Users/hart/dev/applications/personal-website/node_modules/@babel/runtime/regenerator/index.js";
import "./pathseg";
import { PolygonMask } from "./Options/Classes/PolygonMask";
import { PolygonMaskInstance } from "./PolygonMaskInstance";

var PolygonMaskPlugin = /*#__PURE__*/function () {
  function PolygonMaskPlugin(engine) {
    _classCallCheck(this, PolygonMaskPlugin);

    this.id = "polygonMask";
    this._engine = engine;
  }

  _createClass(PolygonMaskPlugin, [{
    key: "getPlugin",
    value: function getPlugin(container) {
      return new PolygonMaskInstance(container, this._engine);
    }
  }, {
    key: "loadOptions",
    value: function loadOptions(options, source) {
      if (!this.needsPlugin(source)) {
        return;
      }

      var optionsCast = options;
      var polygonOptions = optionsCast.polygon;

      if ((polygonOptions === null || polygonOptions === void 0 ? void 0 : polygonOptions.load) === undefined) {
        optionsCast.polygon = polygonOptions = new PolygonMask();
      }

      polygonOptions.load(source === null || source === void 0 ? void 0 : source.polygon);
    }
  }, {
    key: "needsPlugin",
    value: function needsPlugin(options) {
      var _a, _b, _c;

      return (_b = (_a = options === null || options === void 0 ? void 0 : options.polygon) === null || _a === void 0 ? void 0 : _a.enable) !== null && _b !== void 0 ? _b : ((_c = options === null || options === void 0 ? void 0 : options.polygon) === null || _c === void 0 ? void 0 : _c.type) !== undefined && options.polygon.type !== "none";
    }
  }]);

  return PolygonMaskPlugin;
}();

export function loadPolygonMaskPlugin(_x) {
  return _loadPolygonMaskPlugin.apply(this, arguments);
}

function _loadPolygonMaskPlugin() {
  _loadPolygonMaskPlugin = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(engine) {
    var plugin;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            plugin = new PolygonMaskPlugin(engine);
            _context.next = 3;
            return engine.addPlugin(plugin);

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _loadPolygonMaskPlugin.apply(this, arguments);
}

export * from "./Enums/PolygonMaskInlineArrangement";
export * from "./Enums/PolygonMaskMoveType";
export * from "./Enums/PolygonMaskType";
export * from "./Options/Interfaces/IPolygonMaskOptions";